export default "__VITE_ASSET__511bf949__"